import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import mainMap from "../../../assets/city.jpg";
import { MapMainViewPoi } from "../components/MapMainViewPoi";
import parse from "html-react-parser";

export const MapMainView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          width: "100vw",
          height: "100vh",
          backgroundImage: `url(${mainMap})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <MapMainViewPoi path="/engin" x={18} y={35} color="primary">
        {parse(t(`ui.info.engin.name`))}
      </MapMainViewPoi>
      <MapMainViewPoi path="/exchange" x={38} y={15} color="secondary">
        {parse(t(`ui.info.exchange.name`))}
      </MapMainViewPoi>
      <MapMainViewPoi path="/labo" x={60} y={32} color="success">
        {parse(t(`ui.info.labo.name`))}
      </MapMainViewPoi>
    </>
  );
};
